import * as types from './constants';

// Add Lookbook Users
export const addLookbookUsersRequest = data => (
  { type: types.ADD_LOOKBOOK_USERS_REQUEST, payload: data }
);

export const addLookbookUsersDone = data => (
  { type: types.ADD_LOOKBOOK_USERS_DONE, payload: data }
);

export const addLookbookUsersFailed = errors => (
  { type: types.ADD_LOOKBOOK_USERS_FAILED, payload: errors }
);

export const addLookbookUsersClearErrors = prop => (
  { type: types.ADD_LOOKBOOK_USERS_CLEAR_ERRORS, payload: prop }
);

export const addLookbookUsersReset = () => (
  { type: types.ADD_LOOKBOOK_USERS_RESET }
);